
const ValuesSection = () => {
  const values = [
    {
      icon: 'ri-lightbulb-line',
      title: 'Innovation',
      description: 'Constantly pushing boundaries to deliver cutting-edge solutions that drive industry transformation and sustainable growth.'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Integrity',
      description: 'Building trust through transparency, honesty, and ethical business practices in every interaction and partnership.'
    },
    {
      icon: 'ri-team-line',
      title: 'Collaboration',
      description: 'Fostering strong partnerships and teamwork to achieve shared success and create lasting value for all stakeholders.'
    },
    {
      icon: 'ri-trophy-line',
      title: 'Excellence',
      description: 'Committed to delivering superior quality and exceeding expectations in every project we undertake and service we provide.'
    }
  ];

  return (
    <section className="py-32 bg-gradient-to-b from-slate-900/30 to-slate-800/30 relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-32 right-20 w-80 h-80 bg-cyan-600/5 rounded-full blur-3xl"></div>
        <div className="absolute bottom-32 left-20 w-96 h-96 bg-blue-600/5 rounded-full blur-3xl"></div>
      </div>

      <div className="relative container mx-auto px-6 max-w-7xl">
        <div className="text-center mb-20">
          <div className="inline-block mb-6">
            <span className="px-4 py-2 bg-cyan-600/20 text-cyan-300 rounded-full text-sm font-medium border border-cyan-400/30">
              Our Foundation
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl font-light text-white mb-8 leading-tight">
            Core <strong className="bg-gradient-to-r from-cyan-400 to-blue-400 bg-clip-text text-transparent">Values</strong>
          </h2>
          <p className="text-lg text-white/80 max-w-3xl mx-auto font-light leading-relaxed">
            The fundamental principles that guide our decisions, shape our culture, and define our commitment to excellence
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {values.map((value, index) => (
            <div
              key={index}
              className="group relative"
            >
              <div className="absolute inset-0 bg-gradient-to-r from-cyan-600/10 to-blue-600/10 rounded-3xl blur-xl group-hover:blur-2xl transition-all duration-500"></div>
              <div className="relative bg-white/8 backdrop-blur-md border border-white/20 rounded-3xl p-8 hover:bg-white/12 hover:border-cyan-400/40 transition-all duration-500 hover:transform hover:scale-105 h-full">
                <div className="w-20 h-20 bg-gradient-to-r from-cyan-500/20 to-blue-500/20 rounded-3xl flex items-center justify-center mb-8 group-hover:scale-110 transition-transform duration-300 border border-cyan-400/30">
                  <i className={`${value.icon} text-3xl text-cyan-400`}></i>
                </div>
                <h3 className="text-2xl font-semibold text-white mb-6 group-hover:text-cyan-100 transition-colors duration-300">{value.title}</h3>
                <p className="text-white/80 leading-relaxed font-light">{value.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ValuesSection;
